import withAuthentication from "./withAuthentication "
import BulletinForm from "./BulletinForm";

const AuthenticatedBulletinForm = withAuthentication(BulletinForm);

export default AuthenticatedBulletinForm;